import React, { useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import { Link, useNavigate } from 'react-router-dom';
import './Profile.css';

const tileColors = {
  cart: '#0cad5e',
  favorites: '#ef4882',
  history: '#a261a7',
  coupons: '#ec529a'
};

const Profile = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) navigate('/', { replace: true });
  }, [user, user?.id, navigate]);

  if (!user) return null;

  return (
    <div className="profile-root">
      <h2 className="profile-greeting">שלום {user.name}</h2>
      <div className="profile-tiles">
        <Link to="/profile/cart" className="profile-tile" style={{ borderColor: tileColors.cart }}>
<div className="tile-icon">
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#0cad5e"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
</div>
          <div className="tile-text">סל קניות</div>
        </Link>
        <Link to="/profile/favorites" className="profile-tile" style={{ borderColor: tileColors.favorites }}>
<div className="tile-icon">
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#ef4882"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
  </svg>
</div>
          <div className="tile-text">מוצרים שאהבתי</div>
        </Link>
        <Link to="/profile/history" className="profile-tile" style={{ borderColor: tileColors.history }}>
<div className="tile-icon">
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#a261a7"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 2h14l2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="16" y2="14" />
    <line x1="8" y1="6" x2="12" y2="6" />
  </svg>
</div>
          <div className="tile-text">היסטוריית קניות</div>
        </Link>
        <Link to="/profile/coupons" className="profile-tile" style={{ borderColor: tileColors.coupons }}>
<div className="tile-icon">
  <svg width="35" height="26" viewBox="0 0 24 24" fill="none" stroke="#ec529a"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 9a3 3 0 0 1 0-6h20a3 3 0 0 1 0 6 3 3 0 0 0 0 6 3 3 0 0 1 0 6H2a3 3 0 0 1 0-6 3 3 0 0 0 0-6z" />
  </svg>
</div>
          <div className="tile-text">הקופונים שלי</div>
        </Link>
      </div>
    </div>
  );
};

export default Profile;
